import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    row: {
        flexDirection: "row",
        alignItems: "center",
        fontWeight: "ultrabold",
    },
});

export type TableRowProps = {
    children?: React.ReactNode,
    key?: string | number,
    style?: any;
};

export default function TableRow({ children, style }: TableRowProps) {
    return (
        <View style={style ?? styles.row}>
            {children}
        </View>
    );
};